import {
  types,
  IGetCapabilitiesSummaryAction,
  IGetCapabilitiesSummarySuccessAction,
  IGetCapabilitiesSummaryFailureAction,
  ICapabilitiesSummary,
  IGetCapabilitiesSummaryCancelAction,
} from '../types/capabilitiesSummary'

export const getCapabilitiesSummary = (
  groupId: string
): IGetCapabilitiesSummaryAction => ({
  type: types.GET_CAPABILITIES_SUMMARY__START,
  groupId,
})

export const getCapabilitiesSummarySuccess = (
  groupId: string,
  data: ICapabilitiesSummary
): IGetCapabilitiesSummarySuccessAction => ({
  type: types.GET_CAPABILITIES_SUMMARY__SUCCESS,
  groupId,
  data,
})

export const getCapabilitiesSummaryFailure = (
  message: string
): IGetCapabilitiesSummaryFailureAction => ({
  type: types.GET_CAPABILITIES_SUMMARY__FAILURE,
  message,
})

export const getCapabilitiesSummaryCancel = (
): IGetCapabilitiesSummaryCancelAction => ({
  type: types.GET_CAPABILITIES_SUMMARY__CANCEL,
})
